import { calcANZValueAdd, calcLocalContent } from "../../utils/calc";
export const decodeProjectLocalContent = (projectLocalContent) => {
    const importValueAdd = calcLocalContent(projectLocalContent.local_value_add);
    const anzValueAdd = calcANZValueAdd(projectLocalContent.local_value_add, projectLocalContent.contract_content);
    return {
        anzValueAdd,
        contractContent: projectLocalContent.contract_content,
        created: new Date(projectLocalContent.created),
        districtValueAdd: projectLocalContent.district_value_add ?? 0,
        id: projectLocalContent.project_local_content_id,
        importValueAdd,
        itemDescription: projectLocalContent.item_description,
        localContentType: projectLocalContent.local_content_type,
        localValueAdd: projectLocalContent.local_value_add,
        projectId: projectLocalContent.project_id,
        regionalValueAdd: projectLocalContent.regional_value_add
    };
};
export const encodeProjectLocalContent = (localContent) => {
    return {
        contract_content: localContent.contractContent,
        created: new Date(),
        district_value_add: localContent.districtValueAdd,
        item_description: localContent.itemDescription,
        local_content_type: localContent.localContentType,
        local_value_add: localContent.localValueAdd,
        project_id: localContent.projectId,
        project_local_content_id: localContent.id,
        regional_value_add: localContent.regionalValueAdd
    };
};
